import React from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../components/Sidebar";
import { useHotels } from "../components/Home/hooks/useHotels";
import { LoadingState, ErrorState } from "../components/UI";
import { AiOutlineSearch, AiOutlineClose } from "react-icons/ai";

function MailsSuccessPage() {
  const navigate = useNavigate();
  const { hotels, loading, error, searchTerm, setSearchTerm } = useHotels();

  if (loading) {
    return <LoadingState message="Chargement des hôtels..." />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">
        <div className="ml-6 mb-4">
          <h1 className="mb-2 text-3xl font-bold text-gray-900">Mails success</h1>
          <p className="text-sm text-gray-600">
            Cliquer directement sur une ligne pour ouvrir le mail succès.
          </p>
        </div>

        <div className="mb-4 ml-6">
          <div className="relative inline-block" style={{ minWidth: "250px" }}>
            <AiOutlineSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Rechercher un hôtel..."
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                aria-label="Effacer la recherche"
                type="button"
              >
                <AiOutlineClose size={18} />
              </button>
            )}
          </div>
        </div>

        <div className="bg-white shadow-md rounded-lg overflow-hidden ml-6">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Hôtel
                  </th>
                  <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {hotels.map((hotel) => {
                  const openMailSuccess = () => navigate(`/hotels/${hotel.id}?tab=mails`, { state: { hotel } });
                  return (
                    <tr
                      key={hotel.id}
                      className="hover:bg-gray-50 cursor-pointer"
                      onClick={openMailSuccess}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          openMailSuccess();
                        }
                      }}
                      tabIndex={0}
                      role="button"
                      aria-label={`Ouvrir le mail succès pour ${hotel.name}`}
                    >
                      <td className="px-3 py-3 text-sm font-medium text-gray-900">
                        {hotel.name}
                      </td>
                      <td className="px-3 py-3 text-right">
                        <button
                          type="button"
                          onClick={(event) => {
                            event.stopPropagation();
                            openMailSuccess();
                          }}
                          className="px-3 py-2 bg-[#365644] text-white rounded-md text-sm font-medium hover:bg-[#2b4737] transition-colors"
                        >
                          Ouvrir
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {hotels.length === 0 && (
                  <tr>
                    <td className="px-3 py-6 text-sm text-gray-500 text-center" colSpan={2}>
                      Aucun hôtel trouvé.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MailsSuccessPage;

